import { Component, OnInit } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { ExcelService } from '../../services/excel.service';
//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { Router, ActivatedRoute } from '@angular/router';
//import { ExcelService } from 'app/services/excel.service';
import { Constants } from '../../config/settings/constants';
import { DatePipe } from '@angular/common';
import {Location} from '@angular/common';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.css']
})
export class PaymentDetailsComponent implements OnInit {

  public isHideTable: boolean = false;
  public errorMsg: string = "";
  public sessionData: any;
  public consumerId: String;
  public paymentDetails: any = [];
  paymentTypeValue: any = 0;
  fromDate: any = null;
  toDate: any = null;
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd-mm-yyyy',
  };
  paymentTypes: any = [
    { value: 0, caption: 'All' },
    { value: 1, caption: 'EMD PAYMENT' },
    { value: 2, caption: 'NET AMOUNT PAYMENT' },
    { value: 3, caption: 'OUTSTANDING PAYMENT' }
  ];
  displayFileDownloadCaution: boolean = false;
  msgToShowWhileDownloadFile: string = Constants.msgToShowWhileDownloadFile;
  displayDateFilterError: boolean = false;

  // private excelService: ExcelService,
  constructor(public http: HttpTestService, public session: sessionServices, 
    public route: ActivatedRoute, public router: Router, private datepipe: DatePipe,private _location:Location,private excelService: ExcelService) { }

  ngOnInit() {
    this.getSession();
    this.consumerId = this.sessionData.consumerId;
    this.http.getPaymentDetails(this.consumerId).subscribe(
      (data) => {
        this.paymentDetails = data;
        if(this.paymentDetails.length === 0){
          this.isHideTable = true;
          this.errorMsg = "No record found";
        }
      }, (error) => {
        // self.errorMsg = error;
      }, () => {

      }
    )
  }

  getSession = function () {
    this.sessionData = this.session.getSessionDetails();
	}

  // back() {
  //  // this.router.navigate(['/InsComponent']);
  //   this._location.back();
  // }

  filterPaymentDetails() {
    if (this.fromDate != null && this.toDate != null
      && (new Date(this.fromDate.jsdate).getTime() > new Date(this.toDate.jsdate).getTime())) {
      this.displayDateFilterError = true;
      setTimeout(() => {
        this.displayDateFilterError = false;
      }, 3000);
      return false;
    }
    let formattedFromDate = (this.fromDate == null || this.fromDate == '') ? '' : (this.datepipe.transform(new Date(this.fromDate.jsdate), 'yyyy-MM-dd'));
    let formattedToDate = (this.toDate == null || this.toDate == '') ? '' : (this.datepipe.transform(new Date(this.toDate.jsdate), 'yyyy-MM-dd'));
    if (formattedFromDate == '' && formattedToDate != '') {
      formattedFromDate = formattedToDate;
    } else if (formattedFromDate != '' && formattedToDate == '') {
      formattedToDate = formattedFromDate;
    }
    let filterString = "";
    if (formattedFromDate == '' && formattedToDate == '') {
      filterString = this.paymentTypeValue;
    } else {
      filterString = (formattedFromDate + ',' + formattedToDate + ',' + this.paymentTypeValue);
    }
    this.isHideTable = false;
    this.errorMsg = "";
    this.http.filterPaymentDetailsByConsumerId(filterString,this.consumerId).subscribe(
      (data) => {
        this.paymentDetails = data;

        if(this.paymentDetails.length === 0){
          this.isHideTable = true;
          this.errorMsg = "No record found";
        }
      }, (error) => {
        // self.errorMsg = error;
      }, () => {

      }
    )
  }

  exportToExcel() {
    this.displayFileDownloadCaution = true;
    setTimeout(() => {
      this.displayFileDownloadCaution = false;
    }, 3000);

    this.excelService.exportAsExcelFile(this.paymentDetails, 'payment_details');
  }

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/payment-details/payment-details.component.ts